import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumber',
  standalone: true
})
export class PhoneNumberPipe implements PipeTransform {
  transform(phoneNumber: string | null): string {
    if (!phoneNumber) {
      return '';
    }

    const digits = phoneNumber.replace(/\D/g, '');

    let countryCode = '';
    let mainNumber = '';

    if (digits.startsWith('52')) {
      countryCode = '+52';
      mainNumber = digits.slice(2);
    } else if (digits.startsWith('1')) {
      countryCode = '+1';
      mainNumber = digits.slice(1);
    } else {
      return phoneNumber;
    }

    return countryCode + ' ' + mainNumber.slice(0, 3) + ' ' + mainNumber.slice(3, 6) + ' ' + mainNumber.slice(6);
  }
}
